import { Component, Input, Output, EventEmitter } from '@angular/core';

import { BreakpointService } from '@library/core/services';

export const SharedKeys = [ 'private', 'owned', 'public' ] as const;
export type SharedKeys = typeof SharedKeys[number];

export function SharedKeysMap( obj: { shared: boolean, owned: boolean }): SharedKeys {
   return obj.shared ? obj.owned ? 'owned' : 'public' : 'private';
}

export enum SharedKeysEnum {
   private = 'Private',
   owned = 'Shared by you',
   public = 'Shared with you',
}

@Component({
   selector: 'lib-status-legend',
   templateUrl: './status-legend.component.html',
   styleUrls: ['./status-legend.component.scss']
})
export class StatusLegendComponent {

   @Input() selected: SharedKeys;
   @Output() clicked: EventEmitter<SharedKeys> = new EventEmitter();

   SharedKeys = SharedKeys;
   SharedKeysEnum = SharedKeysEnum;

   constructor( public breakpoints: BreakpointService ) { }
}
